import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import { PATHS } from './../constants/Define';
import { RoleService } from './../services';
import i18n from '../constants/initLng';
import Role from '../models/Role';

import * as RoleActions from '../actions/roleAction';
import history from '../helpers/history';

function* getListRole() {
    yield takeLatest(Types.ROLE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(RoleService.getRoles, params);
        yield put(RoleActions.dataRoleSuccess(result));
    }, errorHandleRole(Types.ROLE_FAIL)))
}

function* getAllRole() {
    yield takeLatest(Types.ROLE_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(RoleService.getAllRoles, params);
        yield put(RoleActions.dataAllRoleSuccess(result));
    }, errorHandleRole(Types.ROLE_FAIL)))
}

function* getRoleDetail() {
    yield takeLatest(Types.ROLE_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RoleService.getRoleDetail, action.params.id);
        yield put(RoleActions.getUpdateRoleSuccess(result));
    }, errorHandleRole(Types.ROLE_FAIL)))
}

function* createRole() {
    yield takeLatest(Types.ROLE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const role = new Role(action.params.data);
        yield call(RoleService.createRole, role);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), role.name);
        yield put({ type: Types.ROLE_LIST_ACTION, filters: action.params.filters });
        history.push(PATHS.ROLE.LIST.path);
        history.go();
    }, errorHandleRole(Types.ROLE_FAIL)))
}

function* updateRole() {
    yield takeLatest(Types.ROLE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const role = new Role(action.params.data);
        yield call(RoleService.updateRole, role);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), role.name);
        yield put({ type: Types.ROLE_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleRole(Types.ROLE_FAIL)))
}

function* deleteRole() {
    yield takeLatest(Types.ROLE_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RoleService.deleteRole, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.203'));
        yield put({ type: Types.ROLE_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleRole(Types.ROLE_FAIL)))
}

function errorHandleRole(errorActionType) {
    return Func.sagaErrorHandler(function* (e){
        yield put({ type: errorActionType })
    }, 'role');
}

export function* roleSaga() {
    yield all([
        fork(getListRole),
        fork(getAllRole),
        fork(createRole),
        fork(deleteRole),
        fork(getRoleDetail),
        fork(updateRole),
    ])
}
